/**
 * @generated SignedSource<<8a801500e5d4093eeec1647a9f831f70>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UpdateRoleInput = {
  id: string;
  name?: string | null;
  notifyTimeReg?: boolean | null;
  notifyProjectOverview?: boolean | null;
  disabled?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updateRoleMutation$variables = {
  input: UpdateRoleInput;
};
export type updateRoleMutation$data = {
  readonly updateRole: {
    readonly role: {
      readonly " $fragmentSpreads": FragmentRefs<"settingsRoles_role">;
    } | null;
  } | null;
};
export type updateRoleMutation = {
  variables: updateRoleMutation$variables;
  response: updateRoleMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateRoleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateRolePayload",
        "kind": "LinkedField",
        "name": "updateRole",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Role",
            "kind": "LinkedField",
            "name": "role",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "settingsRoles_role"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateRoleMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "UpdateRolePayload",
        "kind": "LinkedField",
        "name": "updateRole",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Role",
            "kind": "LinkedField",
            "name": "role",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "name",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "notifyProjectOverview",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "timeRegCount",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b458a8577cbb38d5eba03b8c2e5fac23",
    "id": null,
    "metadata": {},
    "name": "updateRoleMutation",
    "operationKind": "mutation",
    "text": "mutation updateRoleMutation(\n  $input: UpdateRoleInput!\n) {\n  updateRole(input: $input) {\n    role {\n      ...settingsRoles_role\n      id\n    }\n  }\n}\n\nfragment settingsRoles_role on Role {\n  id\n  name\n  notifyProjectOverview\n  timeRegCount\n}\n"
  }
};
})();

(node as any).hash = "66360606d8bed6a553cff260875492aa";

export default node;
